import React from 'react';
import {
    Card,
    PersonalData,
    PersonalDataProps,
    Certificate,
    ICertificateProps,
    Qualifications,
    IQualificationsProps,
    Exams,
    IExamsProps,
    IExamsGetListProps,
    IExamsList,
    Loader,
    AnimatedTabs,
} from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { push } from 'connected-react-router';
import { Tab } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useLocalErrorHandler } from 'hooks';

const CreatePersonalDataProps = ({
    expertId,
    personalData,
    apiError,
    onPush,
}: Props): PersonalDataProps => {
    const personalDataProps: PersonalDataProps = {
        stateData: expertId && personalData ? personalData : undefined,
        cancel: () => onPush('/ec-experts'),
        apiError,
        onlyWatch: true,
    };

    return personalDataProps;
};

const CreateCertificateProps = ({
    certificateList,
    apiError,
}: Props): ICertificateProps => {
    const certificateProps: ICertificateProps = {
        certificateList,
        onlyWatch: true,
        apiError,
    };

    return certificateProps;
};

const CreateQualificationsProps = ({ qualificationsList, apiError }: Props) => {
    const QualificationsProps: IQualificationsProps = {
        qualificationsList,
        cardTitle: 'Квалификации эксперта',
        cardCategory: 'Список квалификаций, присвоенных эксперту',
        apiError,
    };

    return QualificationsProps;
};

const createExamsProps = ({
 personalData, getExamsList, examsList, onPush,
}: Props) => {
    const expertId = personalData ? personalData.id : undefined;

    const getList = async (data: IExamsGetListProps) => {
        if (expertId) {
            await getExamsList({ expertId, ...data });
        }
    };

    const list = examsList as IExamsList;

    const examsProps: IExamsProps = {
        getList,
        examsList: list,
        handleRowClick: (id: string) => onPush(`/exam/${id}/?from=expert/${expertId}`),
    };

    return examsProps;
};

const ExpertContainer = (props: Props) => {
    const {
        expertId,
        getPersonalData,
        getCertificateList,
        getQualificationsList,
        getExamsList,
        personalData,
        onPush,
        loadingDetails,
        apiError,
    } = props;
    const [selectedTab, setTab] = React.useState('personalData');

    useLocalErrorHandler(props.setErrorHandler);

    React.useEffect(() => {
        if (expertId) {
            const fetchPersonalData = async () => {
                await getPersonalData(expertId);
                getCertificateList(expertId);
                getQualificationsList(expertId);
                getExamsList({ expertId });
            };

            fetchPersonalData();
        }
    }, [expertId, getCertificateList, getPersonalData, getQualificationsList]);

    return (
        <Card
          title={`${expertId ? personalData && `${personalData.lastName} ${personalData.firstName} ${personalData.middleName}` : 'Добавление эксперта'}`}
          category={`${expertId ? `Рег. номер: ${personalData && personalData.regNumber}` : ''}`}
          withBackButton={!!expertId}
          onClickBack={() => onPush('/ec-experts')}
          apiError={apiError}
          show404Error={Boolean(expertId && !personalData)}
          withoutPadding
        >
            <AnimatedTabs
              id="ExpertContainerTabs"
              activeKey={selectedTab}
              onSelect={(key: string) => setTab(key)}
            >
                <Tab eventKey="personalData" title="Личные данные">
                    {loadingDetails
                        ? <Loader />
                        : <PersonalData {...CreatePersonalDataProps({ ...props, setTab })} />}
                </Tab>
                <Tab
                  disabled={!personalData}
                  eventKey="certificate"
                  title="Свидетельство"
                >
                    <Certificate {...CreateCertificateProps({ ...props })} />
                </Tab>
                <Tab
                  disabled={!personalData}
                  eventKey="qualifications"
                  title="Квалификации"
                >
                    <Qualifications {...CreateQualificationsProps({ ...props })} />
                </Tab>
                {expertId && (
                    <Tab disabled={!personalData} eventKey="exams" title="Экзамены">
                        <Exams {...createExamsProps({ ...props })} />
                    </Tab>
                )}
            </AnimatedTabs>
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
    personalData: state.expert.personalData,
    certificateList: state.expert.certificateList,
    qualificationsList: state.expert.qualificationsList,
    examsList: state.expert.examsList,
    loadingDetails: Boolean(state.loading.effects.expert.getPersonalDataAsync),
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getPersonalData: dispatch.expert.getPersonalDataAsync,
    getCertificateList: dispatch.expert.getCertificateListAsync,
    getQualificationsList: dispatch.expert.getQualificationsListAsync,
    getExamsList: dispatch.expert.getExamsListAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ExpertContainer);

interface IProps {
    setTab?: (tab: string) => void;
    expertId: string;
    tab?: string;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
type Props = connectedProps & IProps;
